// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2LCoX","checkmark":"Checkbox_checkmark__2AYhL"};